import React from "react";
import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from "@material-tailwind/react";
import { imageCodes, titleCodes, textCodes } from "../../template_codes/sarphosaung/contact_page_code";

function Contact() {

    const data = [
        {
            label: "Vision Title",
            value: "vision",
            desc: `Vision Paragraph`,
        },

        {
            label: "Mission Title",
            value: "mission",
            desc: `Mission Paragraph`,
        },

        {
            label: "Value Title",
            value: "value",
            desc: `Value Paragraph`,
        },
    ]


    return (
        <div>

            <div className="lg:w-5/6 xl:w-5/6 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 pt-10 px-4 lg:px-14 xl:px-14 pb-32">
                <div>
                    <img src={imageCodes.contact.image} alt="contact" width={480} height={240}></img>
                </div>
                <div className="pt-8 lg:pt-0 xl:pt-0">
                    <h1 className="pb-8 text-xl lg:text-2xl xl:text-2xl leading-8">{titleCodes.contact.title}</h1>
                    <h1 className="pb-4">{textCodes.addr1.text}</h1>
                    <p className="pb-4">{textCodes.addr2.text}</p>
                    <h1 className="py-4">{textCodes.hotline.text}</h1>
                    <h1 className="py-4">{textCodes.viber.text}</h1>
                    <h1 className="py-4">{textCodes.email.text}</h1>
                </div>
            </div>

            <div className="container w-full lg:w-4/6">
                <Tabs value="html">
                    <TabsHeader>
                        {data.map(({ label, value }) => (
                            <Tab key={value} value={value}>
                                {label}
                            </Tab>
                        ))}
                    </TabsHeader>
                    <TabsBody>
                        {data.map(({ value, desc }) => (
                            <TabPanel key={value} value={value}>
                                <div>
                                    <p className="text-center">{desc}</p>
                                </div>
                            </TabPanel>
                        ))}
                    </TabsBody>
                </Tabs>
            </div>

        </div>
    );
}

export default Contact;